<script lang="ts">

  import RangeControl from './RangeControl.svelte';
  import { createEventDispatcher } from 'svelte';
  import type { LinkedRangeControlsPayload } from './types/linked-range-controls-payload';

  export let minValue = 12;
  export let maxValue = 100;
  export let min = 12;
  export let max = 100;
  export let step = 1;
  export let minDiff = 0;

  const handleRangeStartValueChange = (v: CustomEvent<number>) => {
    minValue = v.detail;
    if (minValue >= maxValue) {
      maxValue = minValue + minDiff;
    }
    dispatchCurrentValue();
  }

  const handleRangeEndValueChange = (v: CustomEvent<number>) => {
    maxValue = v.detail;
    if (minValue >= maxValue) {
      minValue = maxValue - minDiff;
    }
    dispatchCurrentValue();
  }

  const dispatch = createEventDispatcher<{valueChange: LinkedRangeControlsPayload}>();

  const dispatchCurrentValue = () => {
    dispatch('valueChange', {minValue, maxValue});
  }
</script>

<div class="row">
  <div class="col-6">
    <RangeControl {min} max={max - minDiff} {step}
                  value={minValue}
                  on:valueChange={handleRangeStartValueChange}>
      <slot name="left"></slot>
    </RangeControl>
  </div>
  <div class="col-6">
    <RangeControl min={min + minDiff} {max} {step}
                  value={maxValue}
                  on:valueChange={handleRangeEndValueChange}>
      <slot name="right"></slot>
    </RangeControl>
  </div>
</div>
